import { render, staticRenderFns } from "./Cannabis.vue?vue&type=template&id=6c63623f&scoped=true&"
import script from "./Cannabis.vue?vue&type=script&lang=js&"
export * from "./Cannabis.vue?vue&type=script&lang=js&"
import style0 from "./Cannabis.vue?vue&type=style&index=0&id=6c63623f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63623f",
  null
  
)

export default component.exports